import { ArrowRight, Building2, MapPin, MessageSquare, Palette, BarChart3, MessageCircle, LinkIcon } from "lucide-react";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";

const features = [
  {
    title: "Crea tu Propiedad",
    description: "Llena un formulario sencillo con la información de tu propiedad: título, precio, descripción, fotos y video. Tu landing profesional estará lista en minutos.",
    gif: "/gifs/crear-propiedad.gif",
    icon: Building2,
    color: "from-purple-500 to-brand-pink"
  },
  {
    title: "Ubicación con Mapa Interactivo",
    description: "Agrega la dirección y el mapa se genera automáticamente. Tus prospectos podrán ver la ubicación exacta de la propiedad sin salir de la landing.",
    gif: "/gifs/mapa.gif",
    icon: MapPin,
    color: "from-blue-500 to-cyan-500"
  },
  {
    title: "Contacto por WhatsApp o Formulario",
    description: "Elige cómo quieres recibir prospectos: formulario de contacto, botón de WhatsApp directo o ambos. Tú decides el método que mejor te funcione.",
    gif: "/gifs/contacto.gif",
    icon: MessageSquare,
    color: "from-green-500 to-emerald-500"
  },
  {
    title: "Personaliza los Colores",
    description: "Adapta cada landing a tu marca. Cambia los colores principales y de acento para que tus propiedades se vean profesionales y consistentes.",
    gif: "/gifs/colores.gif",
    icon: Palette,
    color: "from-pink-500 to-purple-500"
  },
  {
    title: "Tracking y Pixels",
    description: "Conecta Facebook Pixel, Google Analytics, Google Ads y TikTok Pixel. Mide el rendimiento de tus campañas y optimiza tu inversión publicitaria.",
    gif: "/gifs/tracking.gif",
    icon: BarChart3,
    color: "from-amber-500 to-orange-500"
  },
  {
    title: "Dashboard de Leads",
    description: "Visualiza todos tus prospectos en un solo lugar. Filtra por propiedad, revisa sus datos y exporta a CSV para tu seguimiento comercial.",
    gif: "/gifs/leads.gif",
    icon: MessageCircle,
    color: "from-violet-500 to-purple-500"
  },
  {
    title: "Integraciones CRM",
    description: "Conecta tu CRM favorito (GHL, Zapier, Make, N8N) con un webhook. Cada lead nuevo se envía automáticamente a tu sistema de seguimiento.",
    gif: "/gifs/crm.gif",
    icon: LinkIcon,
    color: "from-teal-500 to-cyan-500"
  }
];

export const Services = () => {
  return (
    <section id="funcionalidades" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-20">
          <span className="inline-block bg-purple-100 text-brand-purple px-4 py-1 rounded-full text-sm font-medium mb-4">
            Funcionalidades
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Todo lo que necesitas para{" "}
            <span className="text-brand-purple">vender más</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Herramientas profesionales de marketing inmobiliario, 
            sin necesidad de conocimientos técnicos
          </p>
        </div>

        {/* Features Zigzag */}
        <div className="space-y-24">
          {features.map((feature, index) => {
            const isEven = index % 2 === 0;
            return (
              <div
                key={index}
                className={`flex flex-col ${isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12 lg:gap-16`}
              >
                {/* GIF */}
                <div className="w-full lg:w-[55%] flex-shrink-0">
                  <div className="relative group">
                    <div className={`absolute -inset-1 bg-gradient-to-r ${feature.color} rounded-2xl opacity-20 group-hover:opacity-30 blur-sm transition-opacity`} />
                    <div className="relative rounded-xl overflow-hidden shadow-2xl border border-gray-200">
                      <img
                        src={feature.gif}
                        alt={feature.title}
                        className="w-full h-auto"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>

                {/* Text */}
                <div className="w-full lg:w-[45%]">
                  <div className={`inline-flex p-3 rounded-xl bg-gradient-to-r ${feature.color} mb-5`}>
                    <feature.icon className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4">
                    {feature.title}
                  </h3>
                  <p className="text-lg text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center bg-gradient-to-r from-brand-purple to-brand-pink rounded-2xl p-12 mt-24">
          <h3 className="text-3xl font-bold text-white mb-4">
            ¿Listo para crear tu primera landing?
          </h3>
          <p className="text-white/80 mb-8 text-lg">
            Pago seguro con Stripe. Cancela cuando quieras.
          </p>
          <Button
            size="lg"
            className="bg-white text-brand-purple hover:bg-gray-100 text-lg px-8 py-6"
            onClick={(e) => {
              e.preventDefault();
              if (window.firePixelAndNavigate) {
                window.firePixelAndNavigate('Lead', { content_name: 'CTA Funcionalidades' }, '/register');
              } else {
                window.location.href = '/register';
              }
            }}
          >
            Crear Cuenta
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};
